import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from '@components/shadcn/sheet';

interface ChangelogEntry {
  version: string;
  date: string;
  items: { type: 'new' | 'improvement' | 'fix'; text: string }[];
}

const CHANGELOG: ChangelogEntry[] = [
  {
    version: 'v1.24.0',
    date: '9. Oktober 2026',
    items: [
      {
        type: 'new',
        text: 'Klaus kann nun Einträge wie AV-Verträge oder DSFA direkt in Dieter anlegen/weiterverwenden.',
      },
      {
        type: 'new',
        text: 'Admins können Firmen nun direkt in Dieter mit passenden Klaus-Organisationen verknüpfen.',
      },
    ],
  },
  {
    version: 'v1.23.0',
    date: '7. Oktober 2026',
    items: [
      {
        type: 'new',
        text: 'Eigene Mitarbeiterschulungen mit hochgeladenen Dokumenten anlegen, bearbeiten und archivieren.',
      },
      {
        type: 'new',
        text: 'Mitarbeiter können eigene Schulungen über persönlichen Link ansehen und die Kenntnisnahme bestätigen.',
      },
    ],
  },
  {
    version: 'v1.22.0',
    date: '2. September 2026',
    items: [
      {
        type: 'new',
        text: 'Neue Übersichtsbox im Dashboard warnt vor ablaufenden DSGVO‑Fristen.',
      },
      {
        type: 'new',
        text: 'Benachrichtigungen und E‑Mails informieren automatisch über kritische Fristen.',
      },
      {
        type: 'new',
        text: 'Neue Listen für Betroffenenanfragen und Datenschutzvorfälle mit Friststatus.',
      },
    ],
  },
  {
    version: 'v1.17.0',
    date: '20. August 2026',
    items: [
      {
        type: 'new',
        text: 'Neue Kategorie für Datenschutz-Bausteine: „Community-Plattform“ kann jetzt separat abgedeckt werden.',
      },
      {
        type: 'improvement',
        text: 'Technologie-Scan zeigt nun klar, welche Cookies und Dienste in Ihrer Datenschutzerklärung fehlen.',
      },
      {
        type: 'improvement',
        text: 'Bericht- und Druckansicht für Technologie-Scans können direkt aus der Scanliste geöffnet werden.',
      },
    ],
  },
  {
    version: 'v1.14.0',
    date: '23. Juni 2026',
    items: [
      {
        type: 'new',
        text: 'Automatischer Webseiten-Scan im DSE-Fragebogen: URL eingeben, Dienste werden für Sie vorbefüllt.',
      },
      {
        type: 'new',
        text: 'Hinweisleiste zeigt erkannte Dienste je Kategorie und ermöglicht deren Übernahme mit einem Klick.',
      },
    ],
  },
  {
    version: 'v1.13.0',
    date: '22. Juni 2026',
    items: [
      {
        type: 'new',
        text: 'Mitarbeiter können jetzt archiviert werden, ohne ihre Schulungsdokumentation zu löschen.',
      },
      {
        type: 'new',
        text: 'HTML-Inhalte können nun wahlweise ohne Design kopiert und in Webseiten integriert werden.',
      },
      {
        type: 'new',
        text: 'Beim Einbetten von Dokumenten können Titel und Styles im Einbettungscode flexibel ein- oder ausgeschaltet werden.',
      },
    ],
  },
  {
    version: 'v1.12.0',
    date: '17. Juni 2026',
    items: [
      {
        type: 'new',
        text: 'Im DSE-Assistent kannst du fehlende Dienste melden; wir prüfen sie direkt automatisch und fügen sie ggf. hinzu.',
      },
    ],
  },
  {
    version: 'v1.11.0',
    date: '27. Mai 2026',
    items: [
      {
        type: 'new',
        text: 'Neuer Website-Scan-Einstieg: Besucher können direkt mit Scan-Ergebnis ins Dashboard einsteigen.',
      },
      {
        type: 'new',
        text: 'Website-Scan-Ergebnisse werden beim ersten Konto automatisch übernommen und gespeichert.',
      },
    ],
  },
  {
    version: 'v1.10.0',
    date: '18. Mai 2026',
    items: [
      {
        type: 'new',
        text: 'Bei bestätigter Einwilligung erhalten Admins jetzt automatische E-Mail-Benachrichtigungen.',
      },
      {
        type: 'improvement',
        text: 'Fortschrittsanzeige im Dashboard ignoriert optionales DSFA-Thema und bildet den Status besser ab.',
      },
      {
        type: 'fix',
        text: 'Einwilligungen werden jetzt zuverlässiger erfasst, nur wenn Nutzer aktiv eine Auswahl treffen.',
      },
    ],
  },
  {
    version: 'v1.9.0',
    date: '13. Mai 2026',
    items: [
      {
        type: 'new',
        text: 'Neuer DSGVO-Website-Scanner mit detaillierter Auswertung von Cookies und Drittanbietern verfügbar',
      },
      {
        type: 'new',
        text: 'Scan-Tiefe wählbar (z.B. Schnell-Scan oder Tiefen-Scan) für individuell passende Website-Analysen',
      },
      {
        type: 'new',
        text: 'Scan-Guthaben pro Unternehmen/Mandant sichtbar und durch Zusatzkäufe direkt im Produkt erweiterbar',
      },
      {
        type: 'new',
        text: 'Laufende Website-Scans können nun abgebrochen und aus der Übersicht entfernt werden',
      },
      {
        type: 'improvement',
        text: 'Scan-Ergebnisse jetzt übersichtlicher mit Score, Sicherheits-Header-Check und DSE-Abgleich dargestellt',
      },
    ],
  },
  {
    version: 'v1.7.34',
    date: '11. Mai 2026',
    items: [
      {
        type: 'improvement',
        text: 'Geteilte Live-Dokumente öffnen nun automatisch in der aktuell gewählten Sprache.',
      },
    ],
  },
  {
    version: 'v1.7.1',
    date: '13. April 2026',
    items: [
      {
        type: 'new',
        text: 'Neues „Neuigkeiten“-Fenster mit allen aktuellen Produktänderungen direkt im Konto einsehbar.',
      },
    ],
  },
  {
    version: 'v1.7.0',
    date: '8. April 2026',
    items: [
      {
        type: 'new',
        text: 'Für Subunternehmer können nun Details zur Datenweitergabe erfasst und in Tabellen/PDFs mit ausgegeben werden.',
      },
      {
        type: 'improvement',
        text: 'Fragebögen: Antwort-Buttons zeigen jetzt Tastaturkürzel an und lassen sich direkt per Taste auslösen.',
      },
      {
        type: 'improvement',
        text: 'Mitarbeiter-Schulungsstatus kann nun als übersichtliches PDF mit farbigen Statusanzeigen exportiert werden.',
      },
    ],
  },
  {
    version: 'v1.6.10',
    date: '8. April 2026',
    items: [
      {
        type: 'improvement',
        text: 'Layouts in exportierten DOCX- und PDF-Dokumenten sind klarer und einheitlicher formatiert.',
      },
      {
        type: 'improvement',
        text: 'Tabellen in Dokumenten wirken übersichtlicher dank verbesserter Rahmen- und Zellgestaltung.',
      },
    ],
  },
  {
    version: 'v1.6.9',
    date: '1. April 2026',
    items: [
      {
        type: 'fix',
        text: 'Beim DSB-Paket wird die gebuchte Anzahl an Unternehmen jetzt korrekt berücksichtigt.',
      },
    ],
  },

  {
    version: 'v1.6.7',
    date: '24. März 2026',
    items: [
      {
        type: 'improvement',
        text: 'Whitelabel-Dokumente nutzen nun auch Ihre eigene Domain in Links und Nennungen.',
      },
    ],
  },
  {
    version: 'v1.6.6',
    date: '23. März 2026',
    items: [
      {
        type: 'improvement',
        text: 'Whitelabel-Kunden sehen in Dokumenten und Texten ihren eigenen Markennamen statt „Dieter“.',
      },
      {
        type: 'improvement',
        text: 'Bei Whitelabel-Konten wird der Standard-Footer unter Dokumenten nicht mehr angezeigt.',
      },
    ],
  },
  {
    version: 'v1.6.5',
    date: '19. März 2026',
    items: [
      {
        type: 'improvement',
        text: 'Sammel-E-Mails zu Benachrichtigungen sind nun übersichtlicher nach Unternehmen gruppiert.',
      },
      {
        type: 'improvement',
        text: 'Aus Sammel-E-Mails können Sie sich jetzt mit einem Direktlink sofort in das Dashboard einloggen.',
      },
      {
        type: 'improvement',
        text: 'Bei Wartungsarbeiten bleibt die Anwendung sichtbar, mit Hinweis und automatischer Wiederherstellung.',
      },
      {
        type: 'improvement',
        text: 'Im Super-Expert-Modus werden mehr Antworten automatisch sinnvoll vorausgefüllt.',
      },
    ],
  },
  {
    version: 'v1.6.3',
    date: '18. März 2026',
    items: [
      {
        type: 'fix',
        text: 'Leere Platzhalter werden nun ausgeblendet und nicht mehr versehentlich im Text angezeigt.',
      },
    ],
  },

  {
    version: 'v1.6.0',
    date: '17. März 2026',
    items: [
      {
        type: 'new',
        text: 'Neue Benachrichtigungszentrale im Kopfbereich: Chat‑, Aufgaben- und DSB‑Hinweise auf einen Blick.',
      },
      {
        type: 'new',
        text: 'DSB-verwaltete Kunden erhalten tägliche E-Mail-Übersichten zu neuen Aufgaben, Chats und Änderungen.',
      },
      {
        type: 'improvement',
        text: 'Admins und DSBs sehen erweiterte Prüfprotokolle mit Filtermöglichkeiten für Aktivitäten im Konto.',
      },
      {
        type: 'improvement',
        text: 'DSB-Rollen können nun eigenständig DSB-Daten und Profilbild verwalten (kein Admin nötig).',
      },
      {
        type: 'improvement',
        text: 'Chat- und Aufgabenaktionen werden detailliert protokolliert, um Nachvollziehbarkeit zu erhöhen.',
      },
    ],
  },
  {
    version: 'v1.5.0',
    date: '11. März 2026',
    items: [
      {
        type: 'improvement',
        text: 'Datei-Uploads und -Downloads (inkl. Logos) funktionieren stabiler dank optimierter Speicheranbindung',
      },
    ],
  },

  {
    version: 'v1.4.2',
    date: '10. März 2026',
    items: [
      {
        type: 'improvement',
        text: 'Super-Expertenmodus füllt passende Antworten aus Stammdaten vor, Sie müssen nur noch bestätigen.',
      },
      {
        type: 'improvement',
        text: 'Reine Info- und „Knoten“-Fragen werden im Super-Expertenmodus automatisch übersprungen oder beantwortet.',
      },
      {
        type: 'fix',
        text: 'Nur Administratoren können nun Abonnement-Upgrades anstoßen; andere sehen einen Hinweis.',
      },
    ],
  },
  {
    version: 'v1.4.1',
    date: '9. März 2026',
    items: [
      {
        type: 'new',
        text: 'Chat-Assistent passt Name, Links und Kontakttexte jetzt automatisch an Ihr Whitelabel-Branding an.',
      },
      {
        type: 'new',
        text: 'Whitelabel-Partner können nun eine eigene Support-E-Mail hinterlegen, die Nutzern im Chat angezeigt wird.',
      },
      {
        type: 'improvement',
        text: 'Chat-Begrüßung und Vorschlagsfragen nennen jetzt den Namen Ihres Assistenten statt immer „Dieter“.',
      },
      {
        type: 'improvement',
        text: 'Fragebogenmodus lässt sich im Konto-Menü bequem zwischen Standard, Experten- und Super-Expertenmodus umschalten.',
      },
    ],
  },
  {
    version: 'v1.4.0',
    date: '9. März 2026',
    items: [
      {
        type: 'new',
        text: 'Nach vollständiger Unterschrift erhalten beide Parteien einen Link zum Download des unterschriebenen Vertrags.',
      },
      {
        type: 'new',
        text: 'Sie können unterschriebene Verträge direkt aus der Partnerliste herunterladen.',
      },
      {
        type: 'new',
        text: 'Bei hochgeladenen Verträgen können Sie vor dem Versand die genaue Position beider Unterschriften im Dokument festlegen.',
      },
      {
        type: 'improvement',
        text: 'Beim Kopieren von Links/HTML wird nun klar angezeigt, wenn Inhalte noch geladen werden.',
      },
      {
        type: 'improvement',
        text: 'Manuell eingetragene Partner mit gewählter Richtung und Vertragstyp werden automatisch gespeichert.',
      },
    ],
  },

  {
    version: 'v1.3.6',
    date: '6. März 2026',
    items: [
      {
        type: 'fix',
        text: 'Beim Firmenwechsel werden jetzt auch Aufgaben korrekt neu geladen.',
      },
      {
        type: 'fix',
        text: 'Aufgaben passen sich nun korrekt an, wenn Sie die Firma im Benutzerkontext wechseln.',
      },
    ],
  },
  {
    version: 'v1.3.5',
    date: '6. März 2026',
    items: [],
  },
  {
    version: 'v1.3.4',
    date: '6. März 2026',
    items: [
      {
        type: 'improvement',
        text: 'Im Super-Expertenmodus können Sie in der Agenda direkt zu beliebigen Abschnitten springen.',
      },
      {
        type: 'improvement',
        text: 'Im Super-Expertenmodus werden nun auch automatisch beantwortbare Schritte besser übersprungen.',
      },
    ],
  },

  {
    version: 'v1.3.0',
    date: '5. März 2026',
    items: [
      {
        type: 'new',
        text: 'Neuer Super-Expertenmodus: Alle Fragen eines Fragebogens kompakt in einer Übersicht bearbeiten.',
      },
    ],
  },
  {
    version: 'v1.2.1',
    date: '25. Februar 2026',
    items: [
      {
        type: 'improvement',
        text: 'Einbettung der Dokumente funktioniert nun korrekt auch auf eigenen Domains/Subdomains.',
      },
      {
        type: 'fix',
        text: 'Der Fallback-Link im Einbettungscode öffnet das Dokument nun immer auf der richtigen Domain.',
      },
    ],
  },
  {
    version: 'v1.2.0',
    date: '26. Februar 2026',
    items: [
      {
        type: 'new',
        text: 'Mitarbeiter können jetzt per CSV-Datei importiert und bestehende E-Mail-Adressen aktualisiert werden.',
      },
      {
        type: 'new',
        text: 'Für jede Schulung können Links und Einladungen per E-Mail an einzelne oder alle Mitarbeiter versendet werden.',
      },
      {
        type: 'improvement',
        text: 'Mitarbeiter haben jetzt ein optionales E-Mail-Feld und können direkt im Training-Tab bearbeitet werden.',
      },
      {
        type: 'improvement',
        text: 'Schulungsbestätigungen zeigen nun an, ob sie abgelaufen sind und warum eine erneute Schulung nötig ist.',
      },
      {
        type: 'improvement',
        text: 'Beim Abschluss von Aufgaben kann direkt in den Schulungsbereich weitergeleitet werden, statt nur einen Link zu kopieren.',
      },
    ],
  },
  {
    version: 'v1.1.3',
    date: '26. Februar 2026',
    items: [
      {
        type: 'fix',
        text: 'Einladungs-E-Mails funktionieren nun auch, wenn kein Hauptunternehmen hinterlegt ist.',
      },
    ],
  },
  {
    version: 'v1.1.2',
    date: '21. Februar 2026',
    items: [
      {
        type: 'improvement',
        text: 'Im Expertenmodus werden beim Zurücknavigieren reine Info-Schritte ohne Upload übersprungen.',
      },
    ],
  },
  {
    version: 'v1.1.1',
    date: '21. Februar 2026',
    items: [
      {
        type: 'improvement',
        text: 'Überschriften links werden nun einheitlich und besser lesbar dargestellt',
      },
    ],
  },
  {
    version: 'v1.1.0',
    date: '20. Februar 2026',
    items: [
      {
        type: 'new',
        text: 'Fragebogen können jetzt als neues DOCX mit optimiertem Layout und Textbausteinen heruntergeladen werden.',
      },
      {
        type: 'new',
        text: 'Fragebogen-PDFs lassen sich nun mit verbessertem Layout erzeugen, auch direkt über Freigabe-Links.',
      },
    ],
  },

  {
    version: 'v1.0.0',
    date: '17. Februar 2026',
    items: [
      {
        type: 'new',
        text: ' Beginn der Change-Log Aufzeichnungen 😉',
      },
    ],
  },
];

const TYPE_CONFIG = {
  new: { label: 'Neu', dotClass: 'bg-emerald-400' },
  improvement: { label: 'Verbesserung', dotClass: 'bg-blue-400' },
  fix: { label: 'Bugfix', dotClass: 'bg-amber-400' },
} as const;

export const LATEST_CHANGELOG_VERSION = CHANGELOG[0].version;

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ChangelogSheet({ open, onOpenChange }: Props) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="sm:max-w-md flex flex-col p-0 gap-0">
        {/* Header */}
        <SheetHeader className="px-6 pt-6 pb-4 border-b border-gray-100">
          <div className="flex items-center gap-2">
            <span className="text-xl">🚀</span>
            <SheetTitle className="text-lg font-semibold text-gray-900">Neuigkeiten</SheetTitle>
          </div>
          <SheetDescription className="text-sm text-gray-500">
            Alle Updates und Verbesserungen auf einen Blick.
          </SheetDescription>
        </SheetHeader>

        {/* Scrollable changelog entries */}
        <div className="flex-1 overflow-y-auto px-6 py-4">
          <div className="relative">
            {/* Timeline vertical line */}
            <div className="absolute left-[7px] top-2 bottom-2 w-px bg-gray-200" aria-hidden="true" />

            <ul className="space-y-8">
              {CHANGELOG.map((entry) => (
                <li key={entry.version} className="relative pl-6">
                  {/* Timeline dot */}
                  <div className="absolute left-0 top-1.5 size-[15px] rounded-full border-2 border-gray-300 bg-white" />

                  {/* Version + date */}
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs font-mono font-semibold bg-gray-100 text-gray-700 px-1.5 py-0.5 rounded">
                      {entry.version}
                    </span>
                    <span className="text-xs text-gray-400">{entry.date}</span>
                  </div>

                  {/* Change items */}
                  <ul className="space-y-2">
                    {entry.items.map((item, idx) => (
                      <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
                        <div className="flex items-center gap-1.5 w-24 shrink-0 mt-0.5">
                          <span className={`size-2 rounded-full shrink-0 ${TYPE_CONFIG[item.type].dotClass}`} />
                          <span className="text-[10px] font-medium text-gray-400">{TYPE_CONFIG[item.type].label}</span>
                        </div>
                        <span>{item.text}</span>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
